"use client";

import { c as _c } from "react/compiler-runtime";
import { Barlow_Condensed } from "next/font/google";
import "./globals.css";
import FallbackLayout from "@/layouts/fallback.layout";
const barlowCondensed = Barlow_Condensed({
  variable: "--font-barlow-condensed",
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  style: ["italic", "normal"],
  preload: false,
  adjustFontFallback: false
});
export default function GlobalError(t0) {
  const $ = _c(3);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error.message || $[1] !== reset) {
    t1 = <html><body lang="en" className={`${barlowCondensed.variable}`}><FallbackLayout errorMessage={error.message} reset={reset} /></body></html>;
    $[0] = error.message;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}